module.exports = __webpack_public_path__ + "static/media/delete.919ed75b.svg";